import React, { Component } from 'react'
import { Link } from 'react-router-dom'

class Profile extends Component {
    constructor (props) {
        super(props);
        this.state = {
          username: '',
          password_old: '',
          password: '',
          password_confirmation: '',
          name: '',
          avatar: '',
          errors: []
        };
        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.hasError = this.hasError.bind(this);
        this.renderError = this.renderError.bind(this);
    }
        
    componentDidMount () {
        //get current user
        axios.get('/api/me').then(response => {
            this.setState({
                username: response.data.username,
                password_old: response.data.password,
                password: response.data.password,
                password_confirmation: response.data.password,
                name: response.data.name,
                avatar: response.data.avatar
            });
        });
    }

    handleFieldChange (event) {
        this.setState({
                [event.target.name]: event.target.value
        });
    }

    handleEdit (event) {
        event.preventDefault();
        const { history } = this.props;

        const User = {
          username: this.state.username,
          password_old: this.state.password,
          password: this.state.password,
          password_confirmation: this.state.password_confirmation,
          name: this.state.name,
          avatar: this.state.avatar
        };

        axios.post('/api/profile', User).then(response => {
            if(response.data.success){
                this.props.history.push('/profile');
            } else {
                this.setState({
                    errors: response.data.errors
                });
            }
        })
        .catch(error => {
            this.setState({
                    errors: error.response.data.errors
            });
        });
    }

    hasError () {
        var count = 0;
        $.each(this.state.errors, function () {
            count++;
        });
        return count;
    }

    renderError () {
        if (this.hasError()) {
            return (
                <div className="alert alert-danger">
                    <ul className="reset-list">
                        {Object.keys(this.state.errors).map((key, i) => 
                            <li key={i}>{this.state.errors[key]}</li>
                        )}
                    </ul>
                </div>
            );
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a href="/home">ダッシュボード</a></li>
                                <li className="breadcrumb-item active" aria-current="page">プロフィール</li>
                            </ol>
                        </nav>
                    </div>
                </div>

                <main id="main">
                    <div className="row justify-content-md-center">
                        <div className="col-sm-6">
                            <div className="card mb-3">
                                <div className="card-header p-4 border-bottom-0"><h4 className="mb-0">プロフィール</h4></div>
                                <div className="card-body">
                                    <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right" htmlFor="username">ユーザーID</label>
                                            <div className="col-md-8">
                                                <input type="text" disabled className="form-control p-l-10" value={this.state.username} />
                                                <input id="username" name="username" type="hidden" required value={this.state.username} />
                                            </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right" htmlFor="name">名前</label>
                                        <div className="col-md-8">
                                            <input id="name" name="name" disabled type="text" placeholder="" className="form-control" onChange={this.handleFieldChange} value={this.state.name} />
                                        </div>
                                    </div>
                                    <div className="form-group row d-none">
                                        <label className="col-sm-4 col-form-label text-right" htmlFor="avatar">アバター</label>
                                        <div className="col-md-8">
                                            <input id="avatar" name="avatar" type="text" placeholder="" className="form-control" onChange={this.handleFieldChange} />
                                        </div>
                                    </div>
                                    <div className="form-group row d-none">
                                        <label className="col-sm-4 col-form-label text-right" htmlFor="password_old">現在のパスワード</label>
                                        <div className="col-md-8">
                                            <input id="password_old" name="password_old" type="password" placeholder="" className="form-control" onChange={this.handleFieldChange} />
                                        </div>
                                    </div>
                                    <div className="form-group row d-none">
                                        <label className="col-sm-4 col-form-label text-right" htmlFor="password">新しいパスワード</label>
                                        <div className="col-md-8">
                                            <input id="password" name="password" type="password" placeholder="" className="form-control" onChange={this.handleFieldChange} />
                                        </div>
                                    </div>
                                    <div className="form-group row d-none">
                                        <label className="col-sm-4 col-form-label text-right" htmlFor="password_confirmation">新しいパスワード（確認）</label>
                                        <div className="col-md-8">
                                            <input id="password_confirmation" name="password_confirmation" type="password" placeholder="" className="form-control" onChange={this.handleFieldChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer d-none">
                                    <div className="text-center">
                                        <button onClick={this.handleEdit} className="btn btn-primary btn-radius btn-lg clearfix"><span className="size-inherit">保存する</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </React.Fragment>
        );
    }
}

export default Profile